import React from "react";
import { i18n } from "../../../app/i18n/i18n";
import { HTMLComponent } from "lib/HTMLComponent";
import { useFetchParse } from "lib/hooks/useFetchParse";
import { LoadingSpinner } from "lib/Spinner";
import { DataErrorMsg } from "pages/analystDirectory/AnalystDirectory";
import { features } from "app/features";

export const LoginTerms = () => {
  const termsLegacyUrl = process.env.PUBLIC_URL + "/static/content/Disclaimers/terms-" + i18n.getLanguage();
  const termsUrl = "/research/japi/public/content/Disclaimers/terms-" + i18n.getLanguage();
  const url = features.useContentApiForPages.Login_terms ? termsUrl : termsLegacyUrl;

  const [html, isLoading, err] = useFetchParse(url, undefined, "GET", true, parseTerms);

  if (isLoading) return <LoadingSpinner />;
  if (err) return <DataErrorMsg />;

  return <HTMLComponent className="mt-5 background" html={html} />;
};

const parseTerms = (data) => data.data[0].content;
